import * as tslib_1 from "tslib";
import { ViewContainerRef } from '@angular/core';
import { AoiService } from '../../../services/aoi.service';
import { BaseComponent } from '../../base.component';
var StateComponent = /** @class */ (function (_super) {
    tslib_1.__extends(StateComponent, _super);
    function StateComponent(_vcr, aoiService) {
        var _this = _super.call(this, _vcr, true) || this;
        _this.aoiService = aoiService;
        _this.activate = function () { };
        _this.addResultToMap = function () {
            _this.aoiService.setSearchCriterias([{ type: 'state' }]);
        };
        return _this;
    }
    Object.defineProperty(StateComponent.prototype, "AoiService", {
        get: function () {
            return this.aoiService;
        },
        enumerable: true,
        configurable: true
    });
    return StateComponent;
}(BaseComponent));
export { StateComponent };
